"use strict";
var $ = require("jquery");
var RepositorioBrowserStorage = require("../cache/RepositorioBrowserStorage");


var _cacheStorage = new RepositorioBrowserStorage({ storage: "localStorage" });
var _serverURL = "";
var _v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

var geraTk = function (v, key) {
    var k = [].reduce.call(v, function (v, a, indice, valor) {
        return key[indice % key.length].charCodeAt(0) + a.charCodeAt(0) + indice + valor.length *
            indice;
    }, [0]);
    var temp = [].map.call(v, function (a, i, valor) {
        var indice = (a.charCodeAt(0) + ((valor.length + i) * k + i));
        return key[(indice + i) % key.length] + key[(indice + i) % key.length] + _v[(i + indice) %
            _v.length];
    });
    return Array.apply(null, new Array(200)).map(function (item, indice) {
        return key[(indice + 3) % key.length] + temp[((key[indice % key.length]).charCodeAt(0) +
            indice +
            temp.length * (v.length + (indice % 4 === 0 ? indice : 3))) % temp.length] +
            key[((indice % 2 === 0 ? indice + _v[indice % _v.length].charCodeAt(0) : 5) + temp.length +
                9) %
            key.length];
    }).join("").split("").filter(function (x, n, s) {
        return s.indexOf(x) === n || n % 50 === 0;
    }).join("");
};

var randStr = function (n) {
    return Array.apply(null, new Array(n)).map(function () {
        return _v[Math.floor(Math.random() * _v.length)];
    }).join("");
};

var ajax = function (config) {
    var $ajax = {
        abort: function () { }
    };
    if (config.usaTK) {
        config.data = config.data || {};
        var t = randStr(15) + "EscolhaTecnologia" + randStr(20);
        var valorTk = config.url;
        for (var param in config.data) {
            valorTk += (param + config.data[param]);
        }
        var tk = geraTk(valorTk, t);
        //___key___
        config.data[String.fromCharCode(95, 95, 95, 107, 101, 121, 95, 95, 95)] = t;
        //___token___
        config.data[String.fromCharCode(95, 95, 95, 116, 111, 107, 101, 110, 95, 95, 95)] = tk;
    }
    var p = new Promise(function (resolve, reject) {
        if (_serverURL && config.url.indexOf("http") === -1) {
            config.url = _serverURL + config.url;
        }
        _cacheStorage.getItem(config.keyCache).then(function (value) {
            if (config.keyCache && value) {
                console.log("cache: " + config.keyCache);
                resolve(value);
                return;
            }
            $ajax = $.ajax(config).done(function (resposta) {
                if (config.keyCache) {
                    _cacheStorage.setItem(
                        config.keyCache,
                        resposta,
                        config.timeoutCache
                    ).then(function () {
                        resolve(resposta);
                    });
                    return;
                }
                resolve(resposta);
            }).fail(function (xhr, status) {
                reject(status);
            });
        });
        return;
    });
    p.abortAjax = function () {
        $ajax.abort();
    };

    return p;
};

ajax.setServerURL = function (serverURL) {
    _serverURL = serverURL;
};

module.exports = ajax;

